import { render, staticRenderFns } from "./BrokerOfRecord.vue?vue&type=template&id=4ed004f1&scoped=true&"
import script from "./BrokerOfRecord.vue?vue&type=script&lang=js&"
export * from "./BrokerOfRecord.vue?vue&type=script&lang=js&"
import style0 from "./BrokerOfRecord.vue?vue&type=style&index=0&id=4ed004f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed004f1",
  null
  
)

export default component.exports